var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircleOutlined = function SvgCheckCircleOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "m10.75 16.414 6.707-6.707-1.414-1.414-5.293 5.293-2.793-2.793-1.414 1.414z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    fillRule: "evenodd",
    d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10 8a8 8 0 1 1 0-16 8 8 0 0 1 0 16",
    clipRule: "evenodd"
  })));
};
export default SvgCheckCircleOutlined;